// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MFaES_CNzPfJYjvO7CwN {
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/MenuItemWrapper/MenuItemWrapper.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAgB;AAClB","sourcesContent":[".menuItemWrapper {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuItemWrapper": `MFaES_CNzPfJYjvO7CwN`
};
export default ___CSS_LOADER_EXPORT___;
